import React from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
import Button from "component/atoms/button";
import SVGIcon from "assets/icon";
import Constants from "core/constants/index";
import Cache from "core/cache/index";
// import ReportDialog from "component/molecules/reportDialog";
// import {
//   generateSarcopeniaReportPdf,
//   getDicomPatientDefaults,
// } from "component/util/sarcopeniaReport";
// → PDF Report 버튼 + 입력 다이얼로그 대신 Auto 화면 같은 Report 카드 (2026-11-04)
import ReportPanel from "component/molecules/reportPanel";

@inject("sarcopeniaMeasureStore")
@observer
@Autobind
class ExportPanel extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
  };

  state = {
    showReportDialog: false,
  };

  // 마지막으로 입력한 환자 정보 (다이얼로그 재오픈 시 유지)
  lastPatient = null;

  handleOpenReportDialog() {
    const { disabled, sarcopeniaMeasureStore } = this.props;
    if (disabled === true || sarcopeniaMeasureStore._measureDatalist.length === 0) {
      return;
    }
    this.setState({ showReportDialog: true });
  }

  handleCloseReportDialog() {
    this.setState({ showReportDialog: false });
  }

  async handleCreateReport(patient) {
    const { sarcopeniaMeasureStore } = this.props;

    ReactGA.event({
      category: "Export",
      action: "Download PDF report",
    });

    // 다이얼로그의 "Creating..." 상태가 먼저 그려지도록 한 프레임 양보
    await new Promise((resolve) => setTimeout(resolve, 30));
    // generateSarcopeniaReportPdf(sarcopeniaMeasureStore, patient);   // Report 카드(reportPanel)로 옮김

    this.lastPatient = patient;
    this.setState({ showReportDialog: false });
  }

  handleClick() {
    const { disabled } = this.props;

    if (disabled === true) {
      return;
    }

    const { sarcopeniaMeasureStore } = this.props;
    const measurements = sarcopeniaMeasureStore.findAllMeasurements();

    // Send user event to Google Analytics
    if (measurements.length === 0) {
      // before AI analysis
      ReactGA.event({
        category: "Export",
        action: "Download result before AI analysis",
      });
    } else {
      // after AI analysis
      ReactGA.event({
        category: "Export",
        action: "Download result after AI analysis",
      });
    }

    let headerTitleMap = {
      sfat_quality_pixel_avg: "Sfat(-190~-30)_avg(HU)",
      vfat_quality_pixel_avg: "Vfat(-190~-30)_avg(HU)",
      muscle_quality_pixel_avg: "Muscle(-190~150)_avg(HU)",
      IMA_quality_pixel_avg: "IMAT(-190~-30)_avg(HU)",
      LAMA_quality_pixel_avg: "LAMA(-29~29)_avg(HU)",
      NAMA_quality_pixel_avg: "NAMA(30~150)_avg(HU)",
      SMA_quality_pixel_avg: "SMA(-29~150)_avg(HU)",
      sfat_quality_pixel_std: "Sfat(-190~-30)_std(HU)",
      vfat_quality_pixel_std: "Vfat(-190~-30)_std(HU)",
      muscle_quality_pixel_std: "Muscle(-190~150)_std(HU)",
      IMA_quality_pixel_std: "IMAT(-190~-30)_std(HU)",
      LAMA_quality_pixel_std: "LAMA(-29~29)_std(HU)",
      NAMA_quality_pixel_std: "NAMA(30~150)_std(HU)",
      SMA_quality_pixel_std: "SMA(-29~150)_std(HU)",
      sfat_quality_pixel_count: "Sfat(-190~-30)_pixel_cnt",
      vfat_quality_pixel_count: "Vfat(-190~-30)_pixel_cnt",
      muscle_quality_pixel_count: "Muscle(-190~150)_pixel_cnt",
      IMA_quality_pixel_count: "IMAT(-190~-30)_pixel_cnt",
      LAMA_quality_pixel_count: "LAMA(-29~29)_pixel_cnt",
      NAMA_quality_pixel_count: "NAMA(30~150)_pixel_cnt",
      SMA_quality_pixel_count: "SMA(-29~150)_pixel_cnt",
      pixel_spacing_x: "PixelSpacingX",
      pixel_spacing_y: "PixelSpacingY",
      SFAT_Area: "Sfat(-190~-30)(cm^2)",
      VFAT_Area: "Vfat(-190~-30)(cm^2)",
      Muscle_Area: "Muscle(-190~150)(cm^2)",
      IMA_Area: "IMAT(-190~-30)(cm^2)",
      LAMA_Area: "LAMA(-29~29)(cm^2)",
      NAMA_Area: "NAMA(30~150)(cm^2)",
      SMA_Area: "SMA(-29~150)(cm^2)",
    };

    let dataGrid = [];
    let headerTitle = [];
    Constants.FreeTierExportHeader.map((headerKey) => {
      headerTitle.push(headerTitleMap[headerKey]);
    });
    dataGrid.push(headerTitle);

    measurements.map((entry) => {
      let dataRecord = [];
      Constants.FreeTierExportHeader.map((headerKey) => {
        if (entry.hasOwnProperty(headerKey) === true) {
          dataRecord.push(entry[headerKey]);
        }else{
          dataRecord.push("");
        }
      });
      dataGrid.push(dataRecord);
    });
    // data array to csv style
    let csvdata = "";
    dataGrid.map((record) => {
      record.map((value) => {
        csvdata += value + ",";
      });
      csvdata += "\n";
    });
    this.download_csv(csvdata);
  }

  getExportFileName() {
    const defaultName = "PixelCnt_totalRegion(Quality)";
    try {
      const metadataCache = new Cache.Metadata();
      const datasets = metadataCache.get_all();
      if (datasets && datasets.length > 0 && datasets[0].filename) {
        // 업로드한 DICOM 파일명에서 확장자(.dcm 등) 제거
        const baseName = datasets[0].filename.replace(/\.[^/.]+$/, "");
        if (baseName) {
          return baseName;
        }
      }
    } catch (e) {
      console.error(e);
    }
    return defaultName;
  }

  download_csv(csv) {
    var hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = this.getExportFileName() + ".csv";
    hiddenElement.click();
  }
  render() {
    const { sarcopeniaMeasureStore, disabled } = this.props;
    // const hasResult = sarcopeniaMeasureStore._measureDatalist.length > 0;
    // const reportDisabled = disabled === true || !hasResult;

    return (
      <div className="control-item last-item">
        <label className="item-title">{"Export"}</label>
        <div className="item-content">
          <Button
            svgIcon={<SVGIcon.SVGDownloadIcon />}
            visible={true}
            type={"primary"}
            size={"full"}
            onPress={this.handleClick}
            style={{
              height: "40px", // ✅ 원하는 높이
              minHeight: "40px", // 라이브러리 기본값 override
              lineHeight: "40px",
            }}
          >
            Download Result
          </Button>
          {/* PDF Report 버튼 → 아래 Report 카드로 바뀜 (2026-11-04)
          <Button
            svgIcon={<SVGIcon.SVGDownloadIcon />}
            visible={true}
            type={"primary"}
            size={"full"}
            disabled={reportDisabled}
            onPress={this.handleOpenReportDialog}
            style={{
              height: "40px",
              minHeight: "40px",
              lineHeight: "40px",
              marginTop: "8px",
              cursor: reportDisabled ? "not-allowed" : "pointer",
            }}
          >
            PDF Report
          </Button>
          */}
        </div>
        {/* {this.state.showReportDialog && (
          <ReportDialog
            defaults={this.lastPatient || getDicomPatientDefaults()}
            onSubmit={this.handleCreateReport}
            onCancel={this.handleCloseReportDialog}
          />
        )} */}
        <ReportPanel disabled={disabled} />
      </div>
    );
  }
}

export default ExportPanel;
